import { Routes } from '@angular/router';
import { attachmentsUploadingWarningGuard } from '@shared/guards/attachments-uploading-warning/attachments-uploading-warning.guard';
import { isFeatureEnabled } from '@core/feature-flag/feature-flag.guard';
import { HistoryService } from '@app/leasing-company/data-import/history/services/history.service';

export const dataImportRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@app/leasing-company/data-import/data-import.component'),
    children: [
      {
        path: 'import',
        loadComponent: () => import('@app/leasing-company/data-import/import/import.component').then(component => component.ImportComponent),
        canActivate: [isFeatureEnabled('leasing-company.data-import.import')],
        canDeactivate: [attachmentsUploadingWarningGuard],
      },
      {
        path: 'history',
        loadComponent: () => import('@app/leasing-company/data-import/history/history.component').then(component => component.HistoryComponent),
        canActivate: [isFeatureEnabled('leasing-company.data-import.history', '/leasing-company/data-import/import')],
        providers: [HistoryService],
      },
      {
        path: 'batch',
        loadComponent: () => import('@app/leasing-company/data-import/batch/batch.component'),
        canActivate: [isFeatureEnabled('leasing-company.data-import.batch', '/leasing-company/data-import/history')],
      },
      {
        path: '**',
        redirectTo: 'batch',
      },
    ],
  },
];
